import React from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import './CustomPhoneNoView.scss';
import PropTypes from 'prop-types';
import { EMPTY_PLACEHOLDER } from '../../utils/Constants';

const CustomPhoneNoView = (props) => {
  const { value } = props;
  return (
    <div>
      <MuiPhoneNumber
        placeholder={EMPTY_PLACEHOLDER}
        className='custom-phone-view'
        value={value}
        disabled={false}
        defaultCountry={'in'}
        sx={{ '& svg': { height: '1.2rem' } }}
      />
    </div>
  );
};

CustomPhoneNoView.propTypes = {
  value: PropTypes.string.isRequired,
};

export default CustomPhoneNoView;
